import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { searchService } from "../../../services/searchService";
import "./CityGuide.scss";

const CityGuideList = () => {
  const { t } = useTranslation("common");
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);

  const getCityGuidePosts = async () => {
    try {
      setLoading(true);
      const data = await searchService.getCityGuide("216"); // tag as "216" - "city-guide"
      setPosts(data);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCityGuidePosts();
  }, []);

  return (
    <div className="blogListContainer">
      <Helmet>
        <title>{t("cityGuideMetaTitle")}</title>
        <meta
          name="description"
          content={t("cityGuideMetaDescription")}
        />
      </Helmet>
      {loading ? (
        <div className="loader loader-abs"></div>
      ) : (
        posts.map((post) => {
          const processedPost = post.content.rendered
            .replace(/&#8217;|&#8220;|&#8221;/g, `'`)
            .replace(/(<([^>]+)>)/gi, "")
            .replace(/(\.tatsu.*;})/gi, "")
            .replace(/(\[tatsu_section.*;\])/gi, "")
            .replace(/(\[tatsu_section.*\])/gi, "");
          const naviagationURL = `https://www.frankporter.com/blog/${post.slug}`;
          return (
            <div className="postPreview" key={post.id}>
              <a
                href={naviagationURL}
                target="_blank"
                rel="noopener noreferrer"
                className="linkPreview"
              >
                <div className="linkPreview">
                  <div className="mainImageContainer">
                    <img
                      src={post.x_featured_media_medium}
                      alt="featured-media-medium"
                    ></img>
                  </div>
                  <div className="dateSection">
                    {/* <Calendar /> */}
                    <i className="ico ico-calendar" />
                    <div className="main_title">{`${post.date.split("-")[1]}.${
                      post.date.split("-")[0]
                    }`}</div>
                  </div>
                  <div className="postHeader">
                    <h5 className="agFutura">
                      <a
                        href={naviagationURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="linkPreview"
                      >
                        <span
                          dangerouslySetInnerHTML={{
                            __html: post.title.rendered,
                          }}
                        />
                      </a>
                    </h5>
                  </div>
                  <div className={`main_secondary postContent`}>
                    {processedPost}
                  </div>
                </div>
              </a>
            </div>
          );
        })
      )}
    </div>
  );
};

export default CityGuideList;
